import {PriorityRulesState} from "@/store/rules/priority_rules/types";
import {Module} from "vuex";
import {RootState} from "@/store/types";
import {getters} from "@/store/rules/priority_rules/getters";
import {mutations} from "@/store/rules/priority_rules/mutations";
import {actions} from "@/store/rules/priority_rules/actions";

export const state: PriorityRulesState = {
  priorityRules:[]
}

export const priorityRules: Module<PriorityRulesState, RootState> = {
  state,
  getters,
  mutations,
  actions
}